import { NbnService } from '@aglenergy/shared-library/dist/generated-source/api/sales/models/NbnService';
import { accountApiService } from 'app/mobile/services/account/account-api.service';

class AccountService {
  public async getServiceByEncryptedServiceId(encryptedServiceId: string): Promise<NbnService> {
    const mobileAccountResult = await accountApiService.getMobileAccountServices();
    if (mobileAccountResult.accounts.length > 0) {
      const account = mobileAccountResult.accounts.find((x) =>
        x.services.some((svc: any) => svc.encryptedServiceId === encryptedServiceId)
      );
      if (account) {
        return account.services.find((svc: any) => svc.encryptedServiceId === encryptedServiceId);
      }
    }

    return null;
  }
}

export const accountService = new AccountService();
